const COOKIE_NAME = "vsga_admin_session";
const SESSION_HOURS = 24;

interface AdminSession {
  contactId: string;
  ownerId: string | null;
  displayName: string;
  loginAt: number;
}

export function setAdminSession(
  contactId: string,
  ownerId: string | null = null,
  displayName: string = ""
): void {
  const payload: AdminSession = { contactId, ownerId, displayName, loginAt: Date.now() };
  const encoded = btoa(JSON.stringify(payload));
  document.cookie = `${COOKIE_NAME}=${encoded}; max-age=${SESSION_HOURS * 3600}; path=/; SameSite=Lax`;
}

export function getAdminSession(): AdminSession | null {
  const cookies = document.cookie.split(";").map((c) => c.trim());
  const cookie = cookies.find((c) => c.startsWith(`${COOKIE_NAME}=`));
  if (!cookie) return null;

  try {
    const encoded = cookie.slice(COOKIE_NAME.length + 1);
    const payload = JSON.parse(atob(encoded)) as AdminSession;

    if (!payload.contactId || !payload.loginAt) return null;

    const ageMs = Date.now() - payload.loginAt;
    if (ageMs > SESSION_HOURS * 3600 * 1000) {
      clearAdminSession();
      return null;
    }

    return payload;
  } catch {
    clearAdminSession();
    return null;
  }
}

export function clearAdminSession(): void {
  document.cookie = `${COOKIE_NAME}=; max-age=0; path=/; SameSite=Lax`;
}
